var portfolioList = {
	label: {
		caption: "Portfolio List",
		name: "Portfolio",
		currency: "Currency",
		numberOfPositions: "Positions",
		numberOfTransactions: "Transactions",
		actions: "Actions"
	},
	noPortfolios: {
		title: "Info",
		message: "No portfolio has been created yet. Please click on the \"Add portfolio\" button and fill out the form to create a portfolio."
	},
	error: {
		title: "An error occurred",
		portfolioLimitExceeded: "Portfolio limit exceeded"
	},
	createPortfolioAction: "Add Portfolio",
	editPortfolioAction: "Edit Portfolio",
	deletePortfolioAction: "Delete Portfolio",
	showActions: "Show actions"
};
var en = {
	portfolioList: portfolioList
};

export { en as default, portfolioList };
